// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__1SqKM","ScrollX":"Scroll_ScrollX__eicNk","ScrollY":"Scroll_ScrollY__3GRkK"};